

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconLocations = exports["default"] = exports.buttonTypes = exports.buttonSizes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _variables = _interopRequireDefault(require("./constants/variables"));
var _mixins = require("./constants/mixins");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLion = _interopRequireDefault(require("@rosetta/react-lion"));
var _reduxUtils = require("@rosetta/redux-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ActionBtn = _styled["default"].button(function (props) {
  var buttonStyles = _objectSpread(_objectSpread({
    fontFamily: '"NotoSans", "NotoSans_Hebrew", "NotoSans_Arabic", "NotoSans_Hindi", "NotoSans_JP", "NotoSans_KR", "NotoSans_TC", "NotoSans_SC"',
    border: "none",
    borderRadius: 6,
    fontSize: 16,
    textAlign: "center",
    outline: "none"
  }, _mixins.noSelectMixin), {}, {
    ":active": {
      position: "relative",
      top: 2
    }
  });
  if (props.buttonSize === buttonSizes.small) {
    buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
      minWidth: "116px",
      paddingTop: "5px",
      paddingBottom: "5px",
      paddingLeft: "8px",
      paddingRight: "8px"
    });
  } else if (props.buttonSize === buttonSizes.medium) {
    buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
      minWidth: "185px",
      paddingTop: "10px",
      paddingBottom: "10px",
      paddingLeft: "20px",
      paddingRight: "20px"
    });
  } else {
    buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
      minWidth: "185px",
      paddingTop: "15px",
      paddingBottom: "15px",
      paddingLeft: "65px",
      paddingRight: "65px"
    });
  }
  if (props.disabled) {
    buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
      backgroundColor: _variables["default"].lightGrey,
      color: _variables["default"].grey,
      cursor: "not-allowed"
    });
  } else {
    switch (props.type) {
      case "primary":
        buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
          fontWeight: 500,
          backgroundColor: (0, _reduxUtils.extractPath)(props, "theme.primary") || _variables["default"].primary,
          color: _variables["default"].white,
          cursor: "pointer",
          "&:hover ": {
            backgroundColor: (0, _reduxUtils.extractPath)(props, "theme.primaryHover") || _variables["default"].primaryHover
          }
        });
        break;
      case "info":
        buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
          backgroundColor: "inherit",
          color: _variables["default"].confirm,
          cursor: "pointer"
        });
        break;
      case "cancel":
        buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
          backgroundColor: "inherit",
          color: (0, _reduxUtils.extractPath)(props, "theme.primary") || _variables["default"].primary,
          cursor: "pointer",
          "&:hover ": {
            color: (0, _reduxUtils.extractPath)(props, "theme.primaryHover") || _variables["default"].primaryHover
          }
        });
        break;
      case "cancelBare":
        buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
          backgroundColor: "inherit",
          color: (0, _reduxUtils.extractPath)(props, "theme.primary") || _variables["default"].primary,
          cursor: "pointer",
          outline: "none",
          "&:hover ": {
            color: (0, _reduxUtils.extractPath)(props, "theme.primaryHover") || _variables["default"].primaryHover
          }
        });
        break;
      case "cancelBareSmall":
        buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
          backgroundColor: "inherit",
          color: (0, _reduxUtils.extractPath)(props, "theme.primary") || _variables["default"].primary,
          cursor: "pointer",
          fontSize: 11,
          outline: "none",
          "&:hover ": {
            color: (0, _reduxUtils.extractPath)(props, "theme.primaryHover") || _variables["default"].primaryHover
          }
        });
        break;
      case "unused":
        buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
          backgroundColor: _variables["default"].unusedBackground,
          color: _variables["default"].unusedTextColor,
          cursor: "pointer",
          "&:hover ": {
            backgroundColor: (0, _reduxUtils.extractPath)(props, "theme.primary") || _variables["default"].primary,
            color: _variables["default"].white
          }
        });
        break;
      case "darker":
        buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
          backgroundColor: (0, _reduxUtils.extractPath)(props, "theme.primaryDarker") || _variables["default"].primaryDarker,
          color: _variables["default"].white,
          cursor: "pointer",
          fontWeight: "bold"
        });
        break;
      default:
        buttonStyles = _objectSpread(_objectSpread({}, buttonStyles), {}, {
          backgroundColor: (0, _reduxUtils.extractPath)(props, "theme.buttonBackground") || _variables["default"].white,
          color: (0, _reduxUtils.extractPath)(props, "theme.primary") || _variables["default"].primary,
          borderColor: (0, _reduxUtils.extractPath)(props, "theme.primary") || _variables["default"].primary,
          borderStyle: "solid",
          borderWidth: "2px",
          cursor: "pointer",
          "&:hover ": {
            color: (0, _reduxUtils.extractPath)(props, "theme.primaryHover") || _variables["default"].primaryHover,
            borderColor: (0, _reduxUtils.extractPath)(props, "theme.primaryHover") || _variables["default"].primaryHover
          }
        });
    }
  }
  return _objectSpread(_objectSpread({}, buttonStyles), props.style);
});
var IconStringWrapper = _styled["default"].div({
  // so the icon and string align properly
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center"
});
var LionStringWrapper = _styled["default"].div({
  display: "inline-block"
});
var IconWrapper = _styled["default"].div(function (props) {
  return _objectSpread({
    display: "inline-block"
  }, props.iconComponentWrapperStyles);
});
var buttonTypes = {
  primary: "primary",
  "default": "default",
  info: "info",
  cancel: "cancel",
  cancelBare: "cancelBare",
  cancelBareSmall: "cancelBareSmall",
  unused: "unused",
  darker: "darker"
};
exports.buttonTypes = buttonTypes;
var buttonSizes = {
  small: "small",
  medium: "medium",
  large: "large"
};
exports.buttonSizes = buttonSizes;
var iconLocations = {
  left: "left",
  right: "right"
};
exports.iconLocations = iconLocations;
var Button = /*#__PURE__*/function (_PureComponent) {
  _inherits(Button, _PureComponent);
  var _super = _createSuper(Button);
  function Button() {
    var _this;
    _classCallCheck(this, Button);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "lionKey", function () {
      return _this.props.lionkey || _this.props.labelKey;
    });
    _defineProperty(_assertThisInitialized(_this), "lionReplacements", function () {
      return _this.props.replacements || _this.props.labelReplacements;
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/_react["default"].createElement(ActionBtn, {
        type: _this.props.buttonType,
        onClick: _this.props.onClick || _this.props.actionFunc,
        disabled: _this.props.disabled === true,
        "data-qa": _this.props.dataQa || "PromptButton",
        buttonSize: _this.props.buttonSize,
        style: _this.props.style
      }, _this.props.children || /*#__PURE__*/_react["default"].createElement(IconStringWrapper, null, _this.props.iconComponent && _this.props.iconComponentLocation === iconLocations.left && /*#__PURE__*/_react["default"].createElement(IconWrapper, {
        iconComponentWrapperStyles: _this.props.iconComponentWrapperStyles
      }, _this.props.iconComponent), _this.lionKey() ? /*#__PURE__*/_react["default"].createElement(LionStringWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactLion["default"].span, {
        lionkey: _this.lionKey(),
        replacements: _this.lionReplacements()
      })) : /*#__PURE__*/_react["default"].createElement(LionStringWrapper, null, _this.props.labelText), _this.props.iconComponent && _this.props.iconComponentLocation === iconLocations.right && /*#__PURE__*/_react["default"].createElement(IconWrapper, {
        iconComponentWrapperStyles: _this.props.iconComponentWrapperStyles
      }, _this.props.iconComponent)));
    });
    return _this;
  }
  return _createClass(Button);
}(_react.PureComponent);
Button.propTypes = {
  buttonType: _propTypes["default"].string,
  actionFunc: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  labelKey: _propTypes["default"].string,
  labelReplacements: _propTypes["default"].object,
  labelText: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  dataQa: _propTypes["default"].string,
  style: _propTypes["default"].object,
  iconComponent: _propTypes["default"].element,
  // an optional jsx icon component, since not required can accept `null` as well
  iconComponentLocation: _propTypes["default"].string,
  // an optional jsx icon component, since not required can accept `null` as well
  iconComponentWrapperStyles: _propTypes["default"].object,
  buttonSize: _propTypes["default"].string
};
Button.defaultProps = {
  iconComponent: null,
  // since most instances of this button don't have an icon go ahead and set to render nothing by default
  iconComponentLocation: iconLocations.right,
  iconComponentWrapperStyles: {},
  // optional object to add styles to position the icon
  labelReplacements: {},
  buttonSize: buttonSizes.medium
};
var _default = Button;
exports["default"] = _default;